import { useEffect, useRef, useState } from 'react'
import { ExternalLink, WandSparkles } from 'lucide-react'
import { openDihawWidget, loadDihawWidget, widgetUrl } from './dihaw-widget'

export function PropertyAiWidget({ open, onClose }: { open: boolean; onClose: () => void }) {
  const close = useRef(onClose)
  close.current = onClose
  const [failed, setFailed] = useState(false)
  useEffect(() => {
    void loadDihawWidget().catch(() => setFailed(true))
    const listener = () => close.current()
    window.addEventListener('dihaw-widget-close', listener)
    return () => window.removeEventListener('dihaw-widget-close', listener)
  }, [])
  useEffect(() => {
    let active = true
    if (open) void loadDihawWidget().then((widget) => { if (active) widget.open('upload') }).catch(() => {
      if (active) { setFailed(true); close.current() }
    })
    return () => { active = false }
  }, [open])
  return failed ? <a href={widgetUrl} target="_blank" rel="noopener noreferrer" role="alert">Buka Dihaw <ExternalLink size={16} /></a> : null
}

export function PropertyAiToolsPanel({ mode: _mode = 'embedded', onClose: _onClose }: { mode?: 'modal' | 'embedded'; onClose?: () => void }) {
  const [failed, setFailed] = useState(false)
  return <section aria-label="Dihaw">
    <h2>Dihaw</h2>
    <button type="button" className="button" onClick={() => void openDihawWidget().catch(() => setFailed(true))}><WandSparkles size={18} />Edit foto properti</button>
    {failed && <p role="alert">Dihaw belum dapat dibuka di sini. <a href={widgetUrl} target="_blank" rel="noopener noreferrer">Buka Dihaw</a></p>}
  </section>
}
